import { render, staticRenderFns } from "./crearDescuentosLista.vue?vue&type=template&id=617ed4ad&"
import script from "./crearDescuentosLista.vue?vue&type=script&lang=js&"
export * from "./crearDescuentosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports